import React from 'react';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import { useTranslation } from 'react-i18next';
import { CompactPageLayout, compactPageLayoutStyles } from 'common/components/compactPageLayout';
import NotificationsDetails from '../settings/components/notificationsTab/components/notificationsDetails/NotificationsDetails'
import styles from './AdminNotificationsList.module.scss';

const AdminNotificationsScreen = () => {
    const { t } = useTranslation();
    return (
        <ScreenTitle title={t('menu.notifications_default')}>
            <CompactPageLayout title={t('menu.notifications_default') as string} contentAreaClassName={compactPageLayoutStyles.scrollableContent}>
                <div className={styles.content}>      <NotificationsDetails isAdmin={true} /></div>

            </CompactPageLayout>
        </ScreenTitle >

    )
}

export default AdminNotificationsScreen;